import { v4 as uuid } from "uuid";
import { injectable } from "tsyringe";
import { ViewModel } from "../../lib/vvm";
import type { FieldSetProps } from "./FieldSet";

@injectable()
export class FieldSetViewModel extends ViewModel<unknown, FieldSetProps> {
  readonly setRootRef = (section: HTMLElement | null): void => {
    if (!section) {
      return;
    }

    const input = section.querySelector("input");
    const label = section.querySelector("label");
    if (!input || !label) {
      return;
    }

    const id = input.getAttribute("id") || uuid();
    input.setAttribute("id", id);
    label.setAttribute("for", id);
  };
}
